import { Component, computed, Input, ChangeDetectionStrategy } from '@angular/core';

import { DynamicElement, GridComponent, SliderComponent } from '@sirius/common';
import { ProductCardComponent } from '../product-card/product-card.component';
import { ProductCard } from 'shared/models';

interface ProductSliderConfig {
    title: string;
    description: string;
    products: ProductCard[];
    componentName: string;
}

@Component({
    selector: 'ur-product-slider',
    imports: [ProductCardComponent, GridComponent, SliderComponent],
    templateUrl: './product-slider.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './product-slider.component.scss'
})
export class ProductSliderComponent implements DynamicElement {
    @Input() title?: string;
    @Input() description?: string;
    @Input() products?: ProductCard[];

    @Input()
    set config(value: ProductSliderConfig) {
        if (value) {
            this.title = value.title;
            this.description = value.description;
            this.products = value.products;
        }
    }

    productList = computed(() => {
        return this.products?.filter((_, index) => index < 6) ?? [];
    });
}
